import React from 'react';

import { Dropdown } from '@neptune/shared/venus-ui';

import { FilterSearchMatch } from './FilterSearchMatch';

export interface FilterSearchItemProps<T> {
  match: string;
  value: T;
  active: boolean;
  selected?: boolean;
  onClick: React.MouseEventHandler;
}

export const FilterSearchItem = <T,>({ match, active, onClick }: FilterSearchItemProps<T>) => (
  <Dropdown.Item onClick={onClick} active={active}>
    <FilterSearchMatch text={match} />
  </Dropdown.Item>
);
